module.exports = __webpack_public_path__ + "img/letsbutterfly-logo-lite.9192e6ce.png";